import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/joy';
import { ColorPaletteProp } from '@mui/joy/styles';

interface PreferenceSummaryCardProps {
  title: string;
  value: number;
  color?: ColorPaletteProp;
  icon?: React.ReactNode;
}

const PreferenceSummaryCard: React.FC<PreferenceSummaryCardProps> = ({
  title,
  value,
  color = 'primary',
  icon
}) => {
  return (
    <Card variant="soft" color={color}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box>
            <Typography level="body-sm" color="neutral" sx={{ mb: 0.5 }}>
              {title}
            </Typography>
            <Typography level="h3" color={color}>
              {value}
            </Typography>
          </Box>
          {icon && (
            <Box sx={{ color: `${color}.500` }}>
              {icon}
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default PreferenceSummaryCard; 